export type Axis = 'r2_f2' | 'f2_m2'

export type Cell = { x: number; y: number; count: number }

export type SortBy = 'simple_user_id' | 'name' | 'code' | 'email' | 'phone' | 'from_max_date' | 'from_count' | 'r2' | 'f2' | 'm2'
export type SortOrder = 'asc' | 'desc'

export type CrmScoringUser = {
  simple_user_id: number
  code: string
  name: string
  email: string
  phone: string
  from_max_date: string
  from_count: number
  r2: number
  f2: number
  m2: number
}

export type CrmScoringState = {
  axis: Axis
  dateRange: { start: string; end: string }
  matrix: { total: number; cells: Cell[]; loading: boolean }
  selectedCells: Array<[number, number]>
  users: { items: CrmScoringUser[]; total: number; page: number; perPage: number; loading: boolean }
  sort: { sortBy: SortBy; sortOrder: SortOrder }
  snapshotDate: string // 集計時点(YYYY-MM-DD) - 空文字なら最新スナップショット
  searchQuery: string
  checkedUserIds: number[]
}

export const SET_AXIS = 'crmScoring/SET_AXIS' as const
export const SET_DATE_RANGE = 'crmScoring/SET_DATE_RANGE' as const
export const SET_MATRIX_LOADING = 'crmScoring/SET_MATRIX_LOADING' as const
export const SET_MATRIX = 'crmScoring/SET_MATRIX' as const
export const TOGGLE_CELL = 'crmScoring/TOGGLE_CELL' as const
export const CLEAR_SELECTED_CELLS = 'crmScoring/CLEAR_SELECTED_CELLS' as const
export const SET_USERS_LOADING = 'crmScoring/SET_USERS_LOADING' as const
export const SET_USERS = 'crmScoring/SET_USERS' as const
export const SET_USERS_PAGE = 'crmScoring/SET_USERS_PAGE' as const
export const SET_USERS_PER_PAGE = 'crmScoring/SET_USERS_PER_PAGE' as const
export const SET_SORT = 'crmScoring/SET_SORT' as const
export const SET_SNAPSHOT_DATE = 'crmScoring/SET_SNAPSHOT_DATE' as const
export const SET_SEARCH_QUERY = 'crmScoring/SET_SEARCH_QUERY' as const
export const SET_CHECKED_USERS = 'crmScoring/SET_CHECKED_USERS' as const

export const setAxis = (axis: Axis) => ({ type: SET_AXIS, axis })
export const setDateRange = (start: string, end: string) => ({ type: SET_DATE_RANGE, start, end })
export const setMatrixLoading = (loading: boolean) => ({ type: SET_MATRIX_LOADING, loading })
export const setMatrix = (total: number, cells: Cell[]) => ({ type: SET_MATRIX, total, cells })
export const toggleCell = (x: number, y: number) => ({ type: TOGGLE_CELL, x, y })
export const clearSelectedCells = () => ({ type: CLEAR_SELECTED_CELLS })
export const setUsersLoading = (loading: boolean) => ({ type: SET_USERS_LOADING, loading })
export const setUsers = (items: CrmScoringUser[], total: number, page: number, perPage: number) => ({ type: SET_USERS, items, total, page, perPage })
export const setUsersPage = (page: number) => ({ type: SET_USERS_PAGE, page })
export const setUsersPerPage = (perPage: number) => ({ type: SET_USERS_PER_PAGE, perPage })
export const setSort = (sortBy: SortBy, sortOrder: SortOrder) => ({ type: SET_SORT, sortBy, sortOrder })
export const setSnapshotDate = (snapshotDate: string) => ({ type: SET_SNAPSHOT_DATE, snapshotDate })
export const setSearchQuery = (query: string) => ({ type: SET_SEARCH_QUERY, query })
export const setCheckedUsers = (ids: number[]) => ({ type: SET_CHECKED_USERS, ids })

export type CrmScoringAction =
  | ReturnType<typeof setAxis>
  | ReturnType<typeof setDateRange>
  | ReturnType<typeof setMatrixLoading>
  | ReturnType<typeof setMatrix>
  | ReturnType<typeof toggleCell>
  | ReturnType<typeof clearSelectedCells>
  | ReturnType<typeof setUsersLoading>
  | ReturnType<typeof setUsers>
  | ReturnType<typeof setUsersPage>
  | ReturnType<typeof setUsersPerPage>
  | ReturnType<typeof setSort>
  | ReturnType<typeof setSnapshotDate>
  | ReturnType<typeof setSearchQuery>
  | ReturnType<typeof setCheckedUsers>
